import type { VoidFunctionComponent } from 'react';
import useSelectRoles from '../../../hooks/useSelectRoles';
import { selectOptionFactory } from '../../../../../../../utils';

const noRoleOption = selectOptionFactory('none', 'No role');

type Props = {
  roleId?: number;
};

/**
 * On each row of the TeamGroupMembersTable, this dropdown allows the current user
 * to change the role of the member quickly.
 *
 * @param {Props} props - The component props.
 * @param {number} props.roleId - The ID of the role to select.
 */
const TeamGroupMembersTableRoleDropdown: VoidFunctionComponent<Props> = ({ roleId }) => {
  const { roleOptions, isLoading } = useSelectRoles();
  const selectedRole = roleOptions.find(role => role.value === roleId) ?? noRoleOption;

  //  Later this will actually be a dropdown:
  //  https://fossa.atlassian.net/browse/CORE-4666

  return (
    <span>
      {isLoading ? '...' : selectedRole.label}
    </span>
  );
};

export default TeamGroupMembersTableRoleDropdown;
